export default function getRenderedComponentProps(component) {
    if (!component)
        return {};
    if (typeof component === 'object' && 'props' in component)
        return component.props;
    return {};
}
//# sourceMappingURL=getRenderedComponentProps.js.map